export default __webpack_public_path__ + "static/media/splash-login-right.10fbcf6a.svg";